import React, { useState } from "react";
import { Fragment } from "react";
import Skills from "./skills/skills";
import LegalEntity from "./legal-entity/legal-entity";
import Projects from "./projects/projects";
import Categories from "./categories/categories";
import Activity from "./activity/activity";
import Designations from "./designations/designations";
import Customers from "./customers/customers";
import { TabView, TabPanel } from 'primereact/tabview';
import BusinessUnit from "./businessUnit/businessUnit";
import Department from "./department/department";
import LeaveType from "./leave-type/leave-type";
import AbsenceCode from "./absenceCode/absenceCode";

export const MasterCard = () => {
  const [activeIndex, setActiveIndex] = useState(0);

  const items = [
    { label: "Legal Entity", icon: "pi pi-database" },
    { label: "Business Unit", icon: "pi pi-book" },
    { label: "Customers", icon: "pi pi-user" },
    { label: "Categories", icon: "pi pi-bars" },
    { label: "Department", icon: "pi pi-users" },
    { label: "Designations", icon: "pi pi-user-minus" },
    { label: "Activity", icon: "pi pi-cog" },
    { label: "Projects", icon: "pi pi-book" },
    { label: "Skills", icon: "pi pi-slack" },
    { label: "Absence Codes", icon: "pi pi-bookmark" },
    { label: "Leave Type", icon: "pi pi-shield" },

  ];

  const ActiveTab = () => {
    switch (activeIndex) {
      case 0:
        return <LegalEntity />;
      case 1:
        return <BusinessUnit />;
      case 2:
        return <Customers />;
      case 3:
        return <Categories />;
      case 4:
        return <Department />;
      case 5:
        return <Designations />;
      case 6:
        return <Activity />;
      case 7:
        return <Projects />;
      case 8:
        return <Skills />;
      case 9:
        return <AbsenceCode />;
      case 10:
        return <LeaveType />;
      default:
        return <LegalEntity />;
    }
  };

  const getTabBody = (tab) => {
    return (
      <div>
        <span className={tab.icon} style={{ marginRight: "3%" }}></span>
        {tab.label}
      </div>
    );
  };

  return (
    <Fragment>
      <div className="card">
        <TabView
          activeIndex={activeIndex}
          onTabChange={(e) => setActiveIndex(e.index)}
        >
          {items.map((tab) => {
            return (
              <TabPanel key={tab.label} header={getTabBody(tab)}>
                <p className="m-0">
                  <ActiveTab />
                </p>
              </TabPanel>
            );
          })}
        </TabView>
      </div>
    </Fragment>
  );
};